export const DossierStatusPreventUpload = [
  'Cloture',
  'Annule',
  'Refuse',
  'TransfereAOpco2I',
  'TransfereAOpcoAtlas',
  'TransfereAOpcoMobilite',
  'TransfereAOpcommerce'
] as const

export const FactureStatusPreventUpload = [
  'Rejete',
  'Paye',
  'Annule',
  'TransfereAOpco2i',
  'TransfereAOpcoMobilites'
] as const

export type DossierStatusPreventUpload = typeof DossierStatusPreventUpload[number]
export type FactureStatusPreventUpload = typeof DossierStatusPreventUpload[number]
